
export function getUsernameInitials(username: string): string {
  if (username == null) {
    return '';
  }
  return username.split(' ').splice(0, 2).map(name => name[0]?.toUpperCase()).join('');
}


export function capitalizeUsername(username: string): string {
  if (username == null) {
    return '';
  }
  return username.split(' ').map(name => name?.charAt(0).toUpperCase() + name.slice(1)).join(' ');
}
